import { useEffect, useState } from "react";
import { Form, Input, Select, Switch } from "antd";
import type { FormInstance, Rule } from "antd/es/form";
import {
  Actions,
} from "../../shared/constants";
import { LockOutlined, MailOutlined, UserOutlined } from "@ant-design/icons";
import Password from "antd/es/input/Password";
import { requiredRule } from "../../utils/validate";
import { useLazyGetServiceManQuery } from "../../services/serviceMan";

const CompanyUserForm = ({
  mode,
  presentation,
  userForm,
  roles,
  serviceCenters
}: {
  mode: string;
  presentation: "User" | "ServiceMan";
  userForm: FormInstance;
  roles: any[],
  serviceCenters?: any[]
}) => {
  const [isActive, setIsActive] = useState<boolean>(
    mode === Actions.CREATE ? true : userForm.getFieldValue("isActive"),
  );
  const password = Form.useWatch("password", userForm);
  const [getServiceMan, getServiceManResult] = useLazyGetServiceManQuery();
  useEffect(() => {
    if (userForm.getFieldValue("userType") === "Company") {
      getServiceMan({ companyId: userForm.getFieldValue("companyId"), userId: userForm.getFieldValue("id") }).unwrap();
    }
  }, []);
  useEffect(() => {
    if (getServiceManResult.isSuccess) {
      userForm.setFieldValue("serviceCenterIds", getServiceManResult?.data?.serviceCenterIds || []);
    }
  }, [getServiceManResult.isLoading]);
  const validateConfirmPassword = (rule: any, value: string) => {
    if (value && password) {
      if (value === password) {
        return Promise.resolve();
      }
      return Promise.reject(new Error("Passwords don't match"));
    }
    return Promise.resolve();
  };

  return (
    <div className="mb-5">
      <Form.Item name="name" label={<>Name <span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]} >
        <Input size="large" placeholder="Name" prefix={<UserOutlined size={36} className="pr-1.5 text-black opacity-60" />} />
      </Form.Item>
      <Form.Item name="loginName" label={<>Login name <span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[{ required: true, message: "Required" }]} >
        <Input size="large" placeholder="Login name, email address or mobile number" />
      </Form.Item>
      <Form.Item name="email" label={<>Email address<span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[{ required: true, type: "email", message: "Required" }]} >
        <Input inputMode="email" size="large" placeholder="Email address" prefix={<MailOutlined size={36} className="pr-1.5 text-black opacity-60" />} />
      </Form.Item>
      <Form.Item name="mobileNo" label={<>Mobile number <span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]}>
        <Input inputMode="tel" size="large" placeholder="Mobile number" />
      </Form.Item>
      {mode === Actions.CREATE && <Form.Item name="password" label={<>Password <span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule]}>
        <Password size="large" placeholder="Password" prefix={<LockOutlined size={36} className="pr-1.5 text-black opacity-60" />} />
      </Form.Item>}
      {mode === Actions.CREATE && <Form.Item name="confirmPassword" label={<>Confirm password <span style={{ color: "red", marginLeft: "2px" }}>*</span></>} rules={[requiredRule, { validator: validateConfirmPassword }]}>
        <Password size="large" placeholder="Confirm password" prefix={<LockOutlined size={36} className="pr-1.5 text-black opacity-60" />} />
      </Form.Item>}
      {userForm.getFieldValue("userType") === "Company" && <Form.Item
        name="roleId"
        label={<>Role<span style={{ color: "red", marginLeft: "2px" }}>*</span></>}
        rules={[requiredRule]}
      >
        <Select
          size="large"
          options={(roles || []).map(x => ({ label: x.name, value: x.id }))}
          placeholder="Select role"
        />
      </Form.Item>}
      {userForm.getFieldValue("userType") === "Company" && <Form.Item
        name="serviceCenterIds"
        label={<>Assigned Service Centers</>}
      >
        <Select
          mode="multiple"
          size="large"
          options={(serviceCenters || []).map(x => ({ label: x.name, value: x.id }))}
          placeholder="Select service centers"
        />
      </Form.Item>}
      {presentation === "User" && <Form.Item
        name="userType"
        label={<>User type</>}
      >
        <Select
          size="large"
          options={["Developer", "Company", "Customer"].map(x => ({ label: x, value: x }))}
          placeholder="Select type"
        />
      </Form.Item>}
      <div className="flex justify-between">
        <div>
          <div className="form-title">
            Status: {!isActive ? "Inactive" : "Active"}
          </div>
        </div>
        <Form.Item name="isActive" valuePropName="checked" initialValue>
          <Switch
            checked={isActive}
            onChange={(checked: boolean) => {
              setIsActive(checked);
            }}
          />
        </Form.Item>
      </div>
    </div>
  );
};

export default CompanyUserForm;
